import { LetteraDiffida } from '../../../models/lettera-diffida';

export class LetteraDiffidaAdapter {

  letteraDiffida: LetteraDiffida = new LetteraDiffida();

  constructor(letteraDiffida: LetteraDiffida) {
    this.letteraDiffida.id = letteraDiffida.id;
    this.letteraDiffida.tipoLettera = letteraDiffida.tipoLettera ?  JSON.parse(JSON.stringify(letteraDiffida.tipoLettera)) : null;
/*
    if (!this.letteraDiffida.tipoLettera.id){
      this.letteraDiffida.tipoLettera.id = '-1';
    }
*/
    this.letteraDiffida.documenti = letteraDiffida.documenti ? letteraDiffida.documenti : [];
    this.letteraDiffida.dataLettera = letteraDiffida.dataLettera ;
    this.letteraDiffida.mittente = letteraDiffida.mittente ;
    this.letteraDiffida.destinatario = letteraDiffida.destinatario ? JSON.parse(JSON.stringify(letteraDiffida.destinatario)) : null;
    this.letteraDiffida.note = letteraDiffida.note ;
  };
}
